import { useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

const MODULE_GEAENDERT_EVENT = 'aktive-module-geaendert';

/** Nach jedem Modul-/Branchen-Toggle aufrufen, damit alle useAktiveModule-Instanzen
    (ModulRail, ManagementPage, SettingsDrawer, AuftragsAkte) neu laden. */
export function benachrichtigeModulAenderung(): void {
  window.dispatchEvent(new Event(MODULE_GEAENDERT_EVENT));
}

export function useAktiveModule(): Set<string> {
  const [module, setModule] = useState<Set<string>>(new Set());
  useEffect(() => {
    let mounted = true;
    const laden = () => {
      axios
        .get<string[]>(`${API_URL}/api/me/modules`)
        .then((r) => { if (mounted) setModule(new Set(r.data)); })
        .catch(() => {
          // Fallback: leeres Set → alle Module sichtbar wenn API nicht erreichbar
          if (mounted) setModule(new Set());
        });
    };
    laden();
    window.addEventListener(MODULE_GEAENDERT_EVENT, laden);
    return () => {
      mounted = false;
      window.removeEventListener(MODULE_GEAENDERT_EVENT, laden);
    };
  }, []);
  return module;
}
